import { useEffect } from 'react';
import { useWebVitals } from '@/hooks/useWebVitals';
import { useRoutePerformance } from '@/hooks/useRoutePerformance';
import { setRumContext, resetSession, isRumEnabled } from '@/lib/rum';
import { useAuth } from '@/hooks/useAuth';
import { useOrganization } from '@/hooks/useOrganization';

interface RumProviderProps {
  children: React.ReactNode;
}

/**
 * Provider para Real User Monitoring
 * 
 * Responsável por:
 * - Inicializar Web Vitals collection
 * - Tracking de navegação entre rotas
 * - Manter contexto (org_id, user_id) atualizado
 * - Reset de sessão no logout
 */
export function RumProvider({ children }: RumProviderProps) {
  const { user } = useAuth();
  const { currentOrg } = useOrganization();
  
  // Hooks de coleta (só executam se RUM habilitado)
  useWebVitals();
  useRoutePerformance();
  
  // Atualizar contexto quando user/org mudam
  useEffect(() => {
    if (!isRumEnabled()) return;
    
    setRumContext(currentOrg?.id || null, user?.id || null);
  }, [currentOrg?.id, user?.id]);
  
  // Reset sessão no logout
  useEffect(() => {
    if (!isRumEnabled()) return;
    
    if (!user) {
      resetSession();
    }
  }, [user]);
  
  return <>{children}</>;
}
